"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("@mui/material/utils");
var SvgAc = (0, utils_1.createSvgIcon)(react_1.default.createElement(react_1.default.Fragment, {}, react_1.default.createElement("path", { d: "M16.67 17A4.581 4.581 0 0 1 13 15.05l-3.64-4.89A2.57 2.57 0 0 0 7.23 9a2.79 2.79 0 0 0-2.16 1.51l-1.21 2-1.72-1 1.21-2A4.73 4.73 0 0 1 7.12 7 4.51 4.51 0 0 1 11 9l3.68 4.89A2.561 2.561 0 0 0 16.77 15a2.78 2.78 0 0 0 2.16-1.51l1.21-2 1.72 1-1.21 2A4.73 4.73 0 0 1 16.88 17h-.21Z" })), 'SvgAc');
exports.default = SvgAc;
